import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['filter', 'apply'];
    static values = {
        moreLabel: String,
        lessLabel: String,
    };

    #hidden = false

    connect () {
        if (this.hasApplyTarget) {
            this.hideFilters();
        }
    }

    toggle () {
        if (this.#hidden) {
            this.showFilters();
        } else {
            this.hideFilters();
        }
    }

    submit () {
        this.element.requestSubmit();
    }

    showFilters () {
        this.filterTargets.forEach((el) => {
            el.style.display = '';
        });

        this.#hidden = false;
        this.applyTarget.innerText = this.lessLabelValue;
    }

    hideFilters () {
        const containerRect = this.filterTargets[0].parentNode.getBoundingClientRect();

        // Find first item that is on second row (top of item is not top of container)
        let index = this.filterTargets.findIndex((el) => {
            const itemRect = el.getBoundingClientRect();

            return itemRect.top - containerRect.top > 0;
        });

        if (index === -1) {
            return;
        }

        index--;

        let toHide = this.filterTargets[index];

        while (toHide) {
            toHide.style.display = 'none';
            toHide = this.filterTargets[++index];
        }

        this.#hidden = true;
        this.applyTarget.style.display = '';
        this.applyTarget.innerText = this.moreLabelValue;
    }
}
